import { IEnvironment } from './_types/environment.interface';

export const environment: IEnvironment = {
  production: false,
  environment: 'sandbox',
  apiBaseUrl: 'https://sandbox-be.helipagos.com',
  version: '2.0-beta1',
  middleendUrl: 'https://middleend-qa.helipagos.com',
  frontendUrl: 'https://checkout-qa.helipagos.com',
  // Completar con el project API key real de PostHog (mientras sea el placeholder, el init se saltea).
  posthogKey: 'phc_REEMPLAZAR',
  posthogHost: 'https://us.i.posthog.com',
  comprobanteApiUrl: 'https://middleend-qa.helipagos.com',
  comprobantePass: 'I18H;+1@M3j(',
};
